import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const UIFlutterWorkshop2025 = () => {
    const workshopImages = [
        "1.png ",
        "2.png ",
    ];


    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        UI-Flutter Workshop: 10th & 11th September 2025
                                    </h2>
                                    <div className='py-2'>
                                        <p>


                                            A hands-on Flutter UI workshop was conducted for 3rd-year IT students in collaboration with Syncosolve Solutions Private Limited to enhance their mobile app design skills. The session focused on building interactive, user-friendly interfaces with real-time practice.
                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">

                                        <div className="row">
                                            {workshopImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/UI-Flutter-Workshop-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/UI-Flutter-Workshop-2025/${img}`}
                                                            alt={`UI-Flutter-Workshop 2025 Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default UIFlutterWorkshop2025;
